import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { Button } from '@grupoboticario/flora-react';
import { Header } from 'components/Header';
import ClaimsByType from './ClaimsByType';

import { Container, ButtonWrap, Claims, ClaimsWrapper, Title } from './styles';

const Home = (): JSX.Element => {
  const history = useHistoryWithHost();

  return (
    <Container>
      <Header franchisee={false}>
        <ButtonWrap>
          <Button
            size="medium"
            styleSemantic="success"
            onClick={() => history.push('/claim')}
          >
            CONSULTAR SINISTROS
          </Button>
        </ButtonWrap>
      </Header>
      <Claims>
        <Title>
          <span>Movimentações de Sinistros</span>
        </Title>
        <ClaimsWrapper>
          <ClaimsByType type="movement" tableName="tableA" />
          <ClaimsByType type="movement" tableName="tableB" />
          <ClaimsByType type="movement" tableName="tableC" />
        </ClaimsWrapper>
        <Title>
          <span>Status de Sinistros</span>
        </Title>
        <ClaimsWrapper>
          <ClaimsByType type="status" tableName="tableA" />
          <ClaimsByType type="status" tableName="tableB" />
          <ClaimsByType type="status" tableName="tableC" />
        </ClaimsWrapper>
      </Claims>
    </Container>
  );
};

export default Home;
